<!-- DocumentTabs.vue -->
<template>
  <div class="row col-12 mb-4">
    <div class="col-12">
      <ul class="nav nav-tabs" role="tablist">
        <li class="nav-item" v-for="(tab, index) in tabs" :key="index">
          <a class="nav-link" :class="{ 'active': tab.isActive }" :id="'tab' + index" @click="activateTab(index)"
             role="tab">
            Assignment #{{ index + 1 }}
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" @click="addTab">+</a>
        </li>
      </ul>
      <div v-if="tabs.length > 0" class="tab-content mt-4">
        <div class="tab-pane fade" :class="{ 'show active': tab.isActive }" :id="'content' + index" role="tabpanel"
             v-for="(tab, index) in tabs" :key="index">
          <div class="col-12">
            <DocumentAssignComponent :developments="developments"
                                     :users="users"
                                     :document-id="documentId"
                                     :preload-documentable-id="tab.preloadDocumentableId"
                                     :preload-documentable-type="tab.preloadDocumentableType"
                                     :preload-documentable="tab.preloadDocumentable"
                                     :index="index"
                                     @remove-assignment="removeAssignment"
            ></DocumentAssignComponent>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    developments: {
      type: Array,
      default: null,
    },
    users: {
      type: Array,
      default: null,
    },
    documentables: {
      type: Array,
      default: null
    },
    documentId: {
      type: Number,
      default: null,
    }
  },

  mounted() {
    this.setupTabs();
  },

  data() {
    return {
      tabs: [],
      confirmedNonSensitive: false,
    };
  },

  methods: {
    activateTab(index) {
      this.tabs.forEach((tab, tabIndex) => {
        tab.isActive = tabIndex === index;
      });
    },

    setupTabs() {
      if (this.documentables && this.documentables.length > 0) {
        this.documentables.forEach((documentable) => {
          this.addTab(documentable);
        });

        this.activateTab(0);
      }

      // No tabs?
      if (this.tabs.length === 0) {
        this.addTab();
      }
    },

    addTab(documentable = null) {
      this.tabs.forEach((tab) => {
        tab.isActive = false;
      });

      const newTab = {
        isActive: true,
        preloadDocumentableId: documentable ? documentable.documentable_id : null,
        preloadDocumentableType: documentable ? documentable.documentable_type : null,
        preloadDocumentable: documentable ? documentable.documentable : null,
        needsWarning: false
      };
      this.tabs.push(newTab);
    },

    removeAssignment(index) {
      this.tabs.pop(index);

      this.activateTab(0);

      // No tabs? Add one.
      if (this.tabs.length === 0) {
        this.addTab();
      }
    }
  },
};
</script>

<style scoped>
a:hover {
  cursor: pointer;
}
</style>
